export const colHeaders = [
    "TaskId",
    "Client/Entity",
    "Client Number ",
    "Description",
    "Task Type",
    "Period End Date",
    "Task Status",
    "Due Date"
]
